import { createStyles } from "@mantine/core";

export default createStyles ( ( theme, props ) => ( {
	flexContainer: {
		display        : "flex",
		alignItems     : "flex-start",
		justifyContent : "space-between",
		padding        : "2rem",
		width          : "100%",
		background     : props?.viewed === 1 ? "unset" : theme.other.darkMode ? theme.other.paletteNew.darkModeDarkBlue50 : theme.other.paletteNew.primaryDarkBlue10,
		cursor         : "pointer"
	},
	avatar: {
		width  : "3rem",
		height : "3rem"
		// marginTop : "0.5rem"
	 },
	 contentAndTime: {
		width          : "100%",
		display        : "flex",
		alignItems     : props?.activeUpdateTab ? "flex-start" : "flex-end",
		justifyContent : "space-between"
	 },
	 title: {
		fontSize   : "1.5rem",
		marginLeft : "1rem"
	 },
	createdAt: {
		fontSize: "1rem"
	},
	 subTitle: {
		fontSize   : "1.3rem",
		marginLeft : "1rem",
		paddingTop : "0.5rem"
	 },
	 contentItem: {
		width         : "100%",
		display       : "flex",
		flexDirection : "column"
	 },
	 separator: {
		borderTop : `1px solid ${ theme.other.colors.border.primary }`,
		width     : props?.activeUpdateTab ? "100%" : "90%",
		position  : "relative",
		left      : props?.activeUpdateTab ? "unset" : "10%"
	},
	separatorParent: {
		background : props?.viewed === 1 ? "unset" : theme.other.darkMode ? theme.other.paletteNew.darkModeDarkBlue50 : theme.other.paletteNew.primaryDarkBlue10,
		width      : "100%"
	},
	thumbnailContainer: {
		height       : "100%",
		width        : "100%",
		cursor       : "pointer",
		display      : "flex",
		borderRadius : "10px",
		padding      : "1rem 1rem 0 1rem"
	},
	thumbnail: {
		width        : "100%",
		aspectRatio  : "16/9",
		borderRadius : "10px"
	},
	photoContainer: {
		height       : "4rem",
		width        : "4rem",
		cursor       : "pointer",
		display      : "flex",
		borderRadius : "50%",
		padding      : "0rem 0rem 1rem 1rem"
	},
	profilePhoto: {
		...theme.other.responsiveImage,
		borderRadius : "50%",
		outline      : `solid 1px ${ theme.other.paletteNew.darkModeWhite80 }`

	}
} ) );

